import { Carousel, Container, Row, Col } from 'react-bootstrap';
import '../styles/testimonials.css'; // Custom styles
function Testimonials(){

    const testimonials = [
        {
          id: 1,
          name: 'Anoop',
          role: 'Franchise Owner, Natural’s Chalakudy',
          quote: 'We’ve seen a real difference in our brand engagement thanks to BuildEdge Studios’ content management on social media. Their creativity and consistency have helped us connect better with our audience.',
        },
        {
          id: 2,
          name: 'Liya Joseph',
          role: 'Founder & Propterior, Thread Stories',
          quote: 'The digital marketing solutions from BuildEdge Studios have significantly boosted our online presence. Their strategic approach and creative execution make them a reliable partner for digital growth.',
        },
        {
          id: 3,
          name: 'Reghunathan TS',
          role: 'Managing Director, Achoos Interiors Pvt Ltd',
          quote: 'BuildEdge Studios delivered exceptional web development services tailored to our needs. Their team was professional, responsive, and committed to quality. We’re truly impressed with the results!'
        },
        {
            id: 4,
            name: 'Anoop Ramaiah',
            role: 'Managing Director, Adsyuga',
            quote: 'BuildEdge Studios crafted high-impact corporate presentations that perfectly aligned with our brand. Their attention to detail and design sense made all the difference in delivering our message effectively.'
          }
      ];

    return(
        <section id="testimonials">
            <section className="testimonials-section py-5">
                <Container>
                    <Row className="text-center mb-4">
                    <Col>
                        <h1 className="">Testimonials</h1>
                        <p className="lead">Hear from those who’ve experienced the difference.</p>
                    </Col>
                    </Row>
                    <Row>
                    <Col md={{ span: 8, offset: 2 }}>
                        <Carousel
                        indicators={true}
                        controls={false}
                        pause="hover"
                        interval={5000}
                        >
                        {testimonials.map((testimonial) => (
                            <Carousel.Item key={testimonial.id}>
                            <div className="testimonial-card text-center p-4">
                                <p className="quote mb-4"><span>"</span>{testimonial.quote}<span>"</span></p>
                                <h5 className="name">{testimonial.name}</h5>
                                <p className="role text-muted">{testimonial.role}</p>
                            </div>
                            </Carousel.Item>
                        ))}
                        </Carousel>
                    </Col>
                    </Row>
                </Container>
    </section>
      </section>
    )
}

export default Testimonials;